import React from 'react';


import Headers from '../Header/Headers/Headers';
import Navigation from '../Header/Navigation/Navigation';

const Home = () => {
    
    return (
      
        <div >
            
            <div>
           
            <Headers></Headers>
        </div>
            
            
        </div>
    );
};

export default Home;